<div class="common-layout {{ 'is-' + selectedHeaderColor }}" [ngClass]="{
        'is-folded': isFolded,
        'is-side-nav-dark' : isSideNavDark,
        'is-expand' : isExpand
    }">
    <app-header></app-header>
    <app-sidenav></app-sidenav>
    <div class="page-container" [ngClass]="domain === 'FMARKET' ? 'FMARKET' : 'LIFE_HERO'">
        <div class="main-content">
            <!-- <div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
                <h4 class="page-title" style="margin-right: 10px;" (click)="back()">
                    <span class="back">Trở về </span>
                    <span>></span>
                </h4>
                <h4 class="page-title active" *ngIf="breadcrumbs$ | async; let breadcrumbs">
                    {{(breadcrumbs[breadcrumbs.length - 1].label)}}</h4>
            </div> -->
            <router-outlet></router-outlet>
            <router-outlet name="popup"></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>